import { path } from 'ramda'
import { useSelector } from '@/hooks/redux'

type Optional<T> = T | undefined
type Role = 'tenant' | 'landlord'
type OptionalRole = Optional<Role>

const useRole = (): OptionalRole =>
  useSelector<OptionalRole>(path(['session', 'session', 'operation_type']))

export default useRole
